/**
 * WordPress dependencies
 */
import { PanelBody, TextControl, RangeControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
const {
    HeaderTabs,
    ColorControl,
    DynamicSwitcher,
    BackgroundControl,
    ResBoxControl,

    TypographyControl,

    ResRangeControl
} = window.progressmatifyModules;

// obj attributes
import objAttributes from './attributes';

// constants
import { S_HEIGHT, T_TYPO, NU_TYPO, FG_RADIUS, G_RADIUS, F_BG, B_BG } from './constants';

const Inspector = props => {
    const { attributes, setAttributes } = props;
    const {
        progressmatify,
        label,
        // style
        titleColor,
        perCentange
    } = attributes;

    const objAttrs = { attributes, setAttributes, objAttributes };

    return (
        <HeaderTabs
            generalControls={
                <>
                    <PanelBody initialOpen={true}>
                        <TextControl
                            label={__('Label', 'progressmatify-blocks')}
                            value={label}
                            onChange={v =>
                                setAttributes({
                                    label: v
                                })
                            }
                            placeholder={__('Progressmatifybar', 'progressmatify-blocks')}
                        />
                    </PanelBody>
                </>
            }
            styleControls={
                <>
                    {/* style gloabal */}
                    <PanelBody title={__('container', 'progressmatify-blocks')} initialOpen={false}>
                        <RangeControl
                            label={__('Progressmatify', 'progressmatify-blocks')}
                            value={progressmatify}
                            onChange={v =>
                                setAttributes({
                                    progressmatify: v
                                })
                            }
                            min={0}
                            max={100}
                        />
                    </PanelBody>

                    <PanelBody title={__('Height', 'progressmatify-blocks')} initialOpen={false}>
                        <ResRangeControl
                            label={__('Height', 'progressmatify-blocks')}
                            controlName={S_HEIGHT}
                            objAttrs={objAttrs}
                            min={1}
                            max={100}
                        />
                    </PanelBody>
                    <PanelBody title={__('Background', 'progressmatify-blocks')} initialOpen={false}>
                        <DynamicSwitcher
                            options={[
                                {
                                    label: __('Backgroun', 'progressmatify-blocks'),
                                    value: 'Background'
                                },
                                {
                                    label: __('Forground', 'progressmatify-blocks'),
                                    value: 'Forground'
                                }
                            ]}
                            contentMap={{
                                Background: (
                                    <>
                                        <BackgroundControl
                                            label={__('Background ', 'progressmatify-blocks')}
                                            controlName={B_BG}
                                            objAttrs={objAttrs}
                                        />
                                    </>
                                ),
                                Forground: (
                                    <>
                                        <BackgroundControl
                                            label={__('Background', 'progressmatify-blocks')}
                                            controlName={F_BG}
                                            objAttrs={objAttrs}
                                        />
                                    </>
                                )
                            }}
                        />
                    </PanelBody>
                    <PanelBody title={__('Border Radius', 'progressmatify-blocks')} initialOpen={false}>
                        <DynamicSwitcher
                            options={[
                                {
                                    label: __('B-Radius', 'progressmatify-blocks'),
                                    value: 'Radius'
                                },
                                {
                                    label: __('F-Radius', 'progressmatify-blocks'),
                                    value: 'Forground'
                                }
                            ]}
                            contentMap={{
                                Radius: (
                                    <>
                                        <ResBoxControl
                                            label={__('Background Radius', 'progressmatify-blocks')}
                                            controlName={FG_RADIUS}
                                            objAttrs={objAttrs}
                                        />
                                    </>
                                ),
                                Forground: (
                                    <>
                                        <ResBoxControl
                                            label={__('Forground Radius', 'progressmatify-blocks')}
                                            controlName={G_RADIUS}
                                            objAttrs={objAttrs}
                                        />
                                    </>
                                )
                            }}
                        />
                    </PanelBody>
                    <PanelBody title={__('Text', 'progressmatify-blocks')} initialOpen={false}>
                        <ColorControl
                            label={__('Title Color', 'progressmatify-blocks')}
                            color={titleColor}
                            onChange={v => {
                                setAttributes({ titleColor: v });
                            }}
                        />
                        <TypographyControl label={__('Title', 'progressmatify-blocks')} objAttrs={objAttrs} controlName={T_TYPO} />
                    </PanelBody>
                    <PanelBody title={__('Number', 'progressmatify-blocks')} initialOpen={false}>
                        <ColorControl
                            label={__('Number Color', 'progressmatify-blocks')}
                            color={perCentange}
                            onChange={v => {
                                setAttributes({ perCentange: v });
                            }}
                        />
                        <TypographyControl label={__('Number', 'progressmatify-blocks')} objAttrs={objAttrs} controlName={NU_TYPO} />
                    </PanelBody>
                </>
            }
        />
    );
};

export default Inspector;
